var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIconDarkGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SearchBar_Collapsed",
    transform: "translate(-22.000000, -18.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Bar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0658662,26.9065234 L37.6871355,27.2824881 C39.0250429,28.8426048 39.838765,30.8651306 39.838765,33.0811274 C39.838765,38.0070894 35.8456261,42 30.9193825,42 C25.9931389,42 22,38.0070894 22,33.0811274 C22,28.1551655 25.9931389,24.1622549 30.9193825,24.1622549 C33.135506,24.1622549 35.1567753,24.9745583 36.7169811,26.3110171 L37.0957118,25.9350523 L37.0957118,24.848322 L43.9540309,18 L46,20.0458522 L39.1554031,26.9065234 L38.0658662,26.9065234 Z M30.9193825,26.9065234 C27.5080617,26.9065234 24.7444254,29.6700017 24.7444254,33.0811274 C24.7444254,36.490881 27.5080617,39.2557315 30.9193825,39.2557315 C34.329331,39.2557315 37.0943396,36.490881 37.0943396,33.0811274 C37.0943396,29.6700017 34.329331,26.9065234 30.9193825,26.9065234 L30.9193825,26.9065234 Z",
    id: "Shape",
    transform: "translate(34.000000, 30.000000) scale(1, -1) translate(-34.000000, -30.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconDarkGray);
export default __webpack_public_path__ + "static/media/search-icon-dark-gray.6c6932e5855a1667df9dbcae66793e84.svg";
export { ForwardRef as ReactComponent };